[
  {
    "Vendor": "AWS",
    "Image Name": "CommServe",
    "Software Release": "11.42.90",
    "Doc Link": "https://documentation.commvault.com/11.42/software/deploying_commvault_windows_linux_byol_from_aws_marketplace.html\r\n",
    "Hosted Link": "https://aws.amazon.com/marketplace/pp/prodview-27kr2v3rshoda?sr=0-7&ref_=beagle&applicationId=AWSMPContessa",
    "OS Type": "Windows 2025 Datacenter"
  },
  {
    "Vendor": "Azure",
    "Image Name": "CommServe",
    "Software Release": "11.42.90",
    "Doc Link": "https://documentation.commvault.com/11.42/software/deploying_commvault_windows_linux_byol_from_azure_marketplace.html ",
    "Hosted Link": "https://marketplace.microsoft.com/sr-latn-rs/product/saas/commvault.commvaultcloudrockylinux?tab=overview",
    "OS Type": "Windows 2025 Datacenter"
  },
  {
    "Vendor": "GCP",
    "Image Name": "CommServe",
    "Software Release": "11.42.90",
    "Doc Link": "https://documentation.commvault.com/11.42/software/deploying_commvault_windows_linux_byol_from_google_cloud_marketplace.html\r\n",
    "Hosted Link": "https://console.cloud.google.com/marketplace/product/cvlt-marketplace-public/commvault-cloud-on-windows-byol",
    "OS Type": "Windows 2025 Datacenter"
  },
  {
    "Vendor": "VMware",
    "Image Name": "CommServe",
    "Software Release": "11.42.90",
    "Doc Link": "https://documentation.commvault.com/11.42/software/deploying_commvault_windows_linux_byol_from_commvault_store.html\r\n",
    "Hosted Link": "https://cloud.commvault.com/commandcenter/#/softwareStore/32887",
    "OS Type": "Windows 2025 Datacenter"
  },
  {
    "Vendor": "AWS",
    "Image Name": "CommServe",
    "Software Release": "11.42.90",
    "Doc Link": "https://documentation.commvault.com/11.42/software/deploying_commvault_windows_linux_byol_from_aws_marketplace.html\r\n",
    "Hosted Link": "https://aws.amazon.com/marketplace/pp/prodview-6eiyfdyrlf2u6?sr=0-6&ref_=beagle&applicationId=AWSMPContessa",
    "OS Type": "Rocky Linux 9.6"
  },
  {
    "Vendor": "Azure",
    "Image Name": "CommServe",
    "Software Release": "11.42.90",
    "Doc Link": "https://documentation.commvault.com/11.42/software/deploying_commvault_windows_linux_byol_from_azure_marketplace.html ",
    "Hosted Link": "https://marketplace.microsoft.com/sr-latn-rs/product/saas/commvault.commvaultcloudrockylinux?tab=overview",
    "OS Type": "Rocky Linux 9.6"
  },
  {
    "Vendor": "GCP",
    "Image Name": "CommServe",
    "Software Release": "11.42.90",
    "Doc Link": "https://documentation.commvault.com/11.42/software/deploying_commvault_windows_linux_byol_from_google_cloud_marketplace.html\r\n",
    "Hosted Link": "https://console.cloud.google.com/marketplace/product/cvlt-marketplace-public/commvault-cloud-on-rocky-linux-byol",
    "OS Type": "Rocky Linux 9.6"
  },
  {
    "Vendor": "VMware",
    "Image Name": "CommServe",
    "Software Release": "11.42.90",
    "Doc Link": "https://documentation.commvault.com/11.42/software/deploying_commvault_windows_linux_byol_from_commvault_store.html\r\n",
    "Hosted Link": "https://cloud.commvault.com/commandcenter/#/softwareStore/32887",
    "OS Type": "Rocky Linux 9.6"
  },
  {
    "Vendor": "AWS",
    "Image Name": "CommServe",
    "Software Release": "11.42.80",
    "Doc Link": "https://documentation.commvault.com/11.42/software/deploying_commvault_windows_linux_byol_from_aws_marketplace.html\r\n",
    "Hosted Link": "https://aws.amazon.com/marketplace/pp/prodview-27kr2v3rshoda?sr=0-7&ref_=beagle&applicationId=AWSMPContessa",
    "OS Type": "Windows 2025 Datacenter"
  },
  {
    "Vendor": "Azure",
    "Image Name": "CommServe",
    "Software Release": "11.42.80",
    "Doc Link": "https://documentation.commvault.com/11.42/software/deploying_commvault_windows_linux_byol_from_azure_marketplace.html ",
    "Hosted Link": "https://marketplace.microsoft.com/sr-latn-rs/product/saas/commvault.commvaultcloudrockylinux?tab=overview",
    "OS Type": "Windows 2025 Datacenter"
  },
  {
    "Vendor": "GCP",
    "Image Name": "CommServe",
    "Software Release": "11.42.80",
    "Doc Link": "https://documentation.commvault.com/11.42/software/deploying_commvault_windows_linux_byol_from_google_cloud_marketplace.html\r\n",
    "Hosted Link": "https://console.cloud.google.com/marketplace/product/cvlt-marketplace-public/commvault-cloud-on-windows-byol",
    "OS Type": "Windows 2025 Datacenter"
  },
  {
    "Vendor": "VMware",
    "Image Name": "CommServe",
    "Software Release": "11.42.80",
    "Doc Link": "https://documentation.commvault.com/11.42/software/deploying_commvault_windows_linux_byol_from_commvault_store.html\r\n",
    "Hosted Link": "https://cloud.commvault.com/commandcenter/#/softwareStore/32887",
    "OS Type": "Windows 2025 Datacenter"
  },
  {
    "Vendor": "AWS",
    "Image Name": "CommServe",
    "Software Release": "11.42.80",
    "Doc Link": "https://documentation.commvault.com/11.42/software/deploying_commvault_windows_linux_byol_from_aws_marketplace.html\r\n",
    "Hosted Link": "https://aws.amazon.com/marketplace/pp/prodview-6eiyfdyrlf2u6?sr=0-6&ref_=beagle&applicationId=AWSMPContessa",
    "OS Type": "Rocky Linux 9.6"
  },
  {
    "Vendor": "Azure",
    "Image Name": "CommServe",
    "Software Release": "11.42.80",
    "Doc Link": "https://documentation.commvault.com/11.42/software/deploying_commvault_windows_linux_byol_from_azure_marketplace.html ",
    "Hosted Link": "https://marketplace.microsoft.com/sr-latn-rs/product/saas/commvault.commvaultcloudrockylinux?tab=overview",
    "OS Type": "Rocky Linux 9.6"
  },
  {
    "Vendor": "GCP",
    "Image Name": "CommServe",
    "Software Release": "11.42.80",
    "Doc Link": "https://documentation.commvault.com/11.42/software/deploying_commvault_windows_linux_byol_from_google_cloud_marketplace.html\r\n",
    "Hosted Link": "https://console.cloud.google.com/marketplace/product/cvlt-marketplace-public/commvault-cloud-on-rocky-linux-byol",
    "OS Type": "Rocky Linux 9.6"
  },
  {
    "Vendor": "VMware",
    "Image Name": "CommServe",
    "Software Release": "11.42.80",
    "Doc Link": "https://documentation.commvault.com/11.42/software/deploying_commvault_windows_linux_byol_from_commvault_store.html\r\n",
    "Hosted Link": "https://cloud.commvault.com/commandcenter/#/softwareStore/32887",
    "OS Type": "Rocky Linux 9.6"
  },
  {
    "Vendor": "AWS",
    "Image Name": "CommServe",
    "Software Release": "11.42.100",
    "Doc Link": "https://documentation.commvault.com/11.42/software/deploying_commvault_windows_linux_byol_from_aws_marketplace.html\r\n",
    "Hosted Link": "https://aws.amazon.com/marketplace/pp/prodview-27kr2v3rshoda?sr=0-7&ref_=beagle&applicationId=AWSMPContessa",
    "OS Type": "Windows 2025 Datacenter"
  },
  {
    "Vendor": "Azure",
    "Image Name": "CommServe",
    "Software Release": "11.42.100",
    "Doc Link": "https://documentation.commvault.com/11.42/software/deploying_commvault_windows_linux_byol_from_azure_marketplace.html ",
    "Hosted Link": "https://marketplace.microsoft.com/sr-latn-rs/product/saas/commvault.commvaultcloudrockylinux?tab=overview",
    "OS Type": "Windows 2025 Datacenter"
  },
  {
    "Vendor": "GCP",
    "Image Name": "CommServe",
    "Software Release": "11.42.100",
    "Doc Link": "https://documentation.commvault.com/11.42/software/deploying_commvault_windows_linux_byol_from_google_cloud_marketplace.html\r\n",
    "Hosted Link": "https://console.cloud.google.com/marketplace/product/cvlt-marketplace-public/commvault-cloud-on-windows-byol",
    "OS Type": "Windows 2025 Datacenter"
  },
  {
    "Vendor": "VMware",
    "Image Name": "CommServe",
    "Software Release": "11.42.100",
    "Doc Link": "https://documentation.commvault.com/11.42/software/deploying_commvault_windows_linux_byol_from_commvault_store.html\r\n",
    "Hosted Link": "https://cloud.commvault.com/commandcenter/#/softwareStore/32887",
    "OS Type": "Windows 2025 Datacenter"
  },
  {
    "Vendor": "AWS",
    "Image Name": "CommServe",
    "Software Release": "11.42.100",
    "Doc Link": "https://documentation.commvault.com/11.42/software/deploying_commvault_windows_linux_byol_from_aws_marketplace.html\r\n",
    "Hosted Link": "https://aws.amazon.com/marketplace/pp/prodview-6eiyfdyrlf2u6?sr=0-6&ref_=beagle&applicationId=AWSMPContessa",
    "OS Type": "Rocky Linux 9.6"
  },
  {
    "Vendor": "Azure",
    "Image Name": "CommServe",
    "Software Release": "11.42.100",
    "Doc Link": "https://documentation.commvault.com/11.42/software/deploying_commvault_windows_linux_byol_from_azure_marketplace.html ",
    "Hosted Link": "https://marketplace.microsoft.com/sr-latn-rs/product/saas/commvault.commvaultcloudrockylinux?tab=overview",
    "OS Type": "Rocky Linux 9.6"
  },
  {
    "Vendor": "GCP",
    "Image Name": "CommServe",
    "Software Release": "11.42.100",
    "Doc Link": "https://documentation.commvault.com/11.42/software/deploying_commvault_windows_linux_byol_from_google_cloud_marketplace.html\r\n",
    "Hosted Link": "https://console.cloud.google.com/marketplace/product/cvlt-marketplace-public/commvault-cloud-on-rocky-linux-byol",
    "OS Type": "Rocky Linux 9.6"
  },
  {
    "Vendor": "VMware",
    "Image Name": "CommServe",
    "Software Release": "11.42.100",
    "Doc Link": "https://documentation.commvault.com/11.42/software/deploying_commvault_windows_linux_byol_from_commvault_store.html\r\n",
    "Hosted Link": "https://cloud.commvault.com/commandcenter/#/softwareStore/32887",
    "OS Type": "Rocky Linux 9.6"
  }
]